var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM28(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5440_45551",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5440_45551",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByElEQVRo3uWaPY6CQBiGRwtPYKcn0HY9xdpRewNs2BZOYbiOjW6lJngA7a12g2AH7PsZJjHuKj/CMB87ydMYTN4Hnd9vhKig+Z9iCGZgAZbgCM4gSjmnny3TZ+jZoWi49btdYX2vxAZhYpAUJPbXYnuavlmn90lfZfABcMGl2xHx1+r6hpNSrDvRaTqJIXABLhjUGbwHHBCChKhQIEkJgQN6VYcfA08Gr1FAsgfjqsIbILgPX7MAEQDj1fBzEP0VXoEAEYH5K+HjR+EVCRBxGQnj2ZtXLCB/CaNIhw2ywisWkH1inGeo3OcJ34CAHJ2eDrFO3vANCRDOsxk2ZCAQPpqx3SLhGxQg3F8LM1rbMBK43C8AP4qGb1iAsG4FdgwFdjL8MGvG1VSAvnfdFM3KhNdAgKDsYsFYgLKLJWMByi6OjAUOJHBmLEDZs5fNGgtErRDg/BfyW9GJ2Q+j7Ccy9ksJ9os5rsvp7e1+wOK+oWG/pWS/qW/FsQqXgy0762jR01jAy1O90flwd/QvjtdlMzUqcJhlqzSmBiWm0uFbUeSTbaS4zOoV6bBFCt22gkK3XUehuxVXDeq47LFp4rJHnus2B+CruG7zA7uoPl2L+3bBAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM28);
export default __webpack_public_path__ + "static/media/m28.02a4d6117cb9efd3dc28fe22207a4c94.svg";
export { ForwardRef as ReactComponent };